import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36daf8ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profileContainer text-sm sm:mt-8" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer backButton br100 h-10 w-10 flex justify-center items-center absolute" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.5 15.8337L7.69781 11.0315C7.13068 10.4643 7.13068 9.53631 7.69781 8.96918L12.5 4.16699",
      stroke: "white",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_3 = { class: "MyPrivacity p-8 text-sm" }
const _hoisted_4 = { class: "flex items-center justify-center" }
const _hoisted_5 = { class: "mt-12 br16 altBackground p-6" }
const _hoisted_6 = { class: "flex p-8 pl-4 pr-0 items-center justify-center flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("contact_us")), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("questions_issues_or_suggestions")), 1),
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.window.location = 'soporte@taykus.com')),
            class: "textGradient p-1 text-center cursor-pointer text-sm mt-4"
          }, " soporte@taykus.com ")
        ])
      ])
    ])
  ]))
}